<template>
  <div class="charging-order-list">
    <!-- 使用 pageTable 组件 -->
    <pageTable
        ref="table"
        :tableTitle="tableColumn"
        :searchData="searchData"
        :doneFunction="doneFunction"
        tableApi="admin/xindian_order/getOrderLists"
    >
      <!-- 自定义搜索表单项 -->
      <template v-slot:searchFormItem>
        <FormItem prop="id">
          <Input type="text" v-model="searchData.id" placeholder="ID" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="status">
          <Select v-model="searchData.status" placeholder="充电状态" clearable>
            <Option label="启动中" value="1"></Option>
            <Option label="充电中" value="2"></Option>
            <Option label="停止中" value="3"></Option>
            <Option label="已停止" value="4"></Option>
          </Select>
        </FormItem>
        <FormItem prop="station_name">
          <Input type="text" v-model="searchData.station_name" placeholder="站点名称" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="driver_name">
          <Input type="text" v-model="searchData.driver_name" placeholder="司机姓名" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="driver_mobile">
          <Input type="text" v-model="searchData.driver_mobile" placeholder="司机手机号" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="company_id">
          <Input type="text" v-model="searchData.company_id" placeholder="车队ID" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="has_placeholder">
          <Select v-model="searchData.has_placeholder" placeholder="是否有占位费" clearable>
            <Option label="有" value="1"></Option>
            <Option label="无" value="0"></Option>
          </Select>
        </FormItem>
        <FormItem prop="has_refund">
          <Select v-model="searchData.has_refund" placeholder="是否有退款" clearable>
            <Option label="有" value="1"></Option>
            <Option label="无" value="0"></Option>
          </Select>
        </FormItem>
      </template>

      <!-- 其他按钮插槽 -->
      <template v-slot:otherBtn>
        <FormItem>
          <Button type="primary" :loading="exportLoading" @click="exportData">{{ exportLoading ? '导出中...' : '导出' }}</Button>
        </FormItem>
      </template>
    </pageTable>
    <!-- 占位费订单明细弹窗 -->
    <Drawer :title="'占位费订单明细'" width="60%"
            :value="showPlaceholderDialog"
            :mask-closable="true"
            @on-close="showPlaceholderDialog = false">
      <Table :columns="placeholderOrdersColumns" :data="placeholderOrders" :border="true" />
    </Drawer>

    <!-- 退款记录明细弹窗 -->
    <Drawer :title="'退款记录明细'" width="60%"
            :value="showRefundDialog"
            :mask-closable="true"
            @on-close="showRefundDialog = false">
      <Table :columns="refundRecordsColumns" :data="refundRecords" :border="true" />
    </Drawer>
  </div>

</template>

<script>
import pageTable from "@/components/table/pageTable";
import XLSX from "xlsx";

export default {
  name: "chargingOrderList",
  components:{pageTable},
  data() {
    return {
      statistics: {
        total_placeholder_amount: 0,
        total_placeholder_count: 0,
        total_refund_amount: 0,
        total_refund_count: 0
      },
      searchData: {
        status: '',
        id: '',
        driver_name: '', // 司机姓名
        driver_mobile: '', // 司机手机号
        company_id: '', // 车队ID
        has_placeholder: '', // 是否有占位费
        has_refund: '', // 是否有退款
        station_name: '' // 站点名称
      },
      refundRecords: [], // 添加初始值
      placeholderOrders: [], // 添加初始值
      showRefundDialog: false, // 初始化为 false
      showPlaceholderDialog: false, // 初始化为 false
      exportLoading: false, // 导出加载状态
      tableColumn: [
        { title: 'ID', key: 'id', minWidth: 50, align: 'center' },
        { title: '站点名称', key: 'station_name', minWidth: 80, align: 'center' },
        { title: '启动充电流水号', key: 'start_charge_seq', minWidth: 80, align: 'center' },
        {
          title: '司机信息',
          key: 'driver_info',
          minWidth: 145,
          align: 'center',
          render: (h, params) => {
            return h('div', {
              style: {
                fontSize: '12px'
              }
            }, [
              h('p', `姓名：${params.row.driver_name}`),
              h('p', `手机号：${params.row.phone}`),
              h('p', `车牌号：${params.row.plate_no}`)
            ]);
          }
        },
        {
          title: '车队信息',
          key: 'company_info',
          minWidth: 80,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('p', `ID：${params.row.company_id}`),
              h('p', `名称：${params.row.company_name}`)
            ]);
          }
        },

        { title: '总充电量(kWh)', key: 'total_power', minWidth: 60, align: 'center' },
        { title: '总金额(元)', key: 'total_money', minWidth: 70, align: 'center' },
        { title: '预充金额', key: 'charging_amt', minWidth: 70, align: 'center' },
        {
          title: '预充退款信息',
          key: 'refund_info',
          minWidth: 125,
          align: 'center',
          render: (h, params) => {
            const hasRefund = params.row.has_refund;
            const amount = params.row.refund_total_amount_format;
            return h('div', [
              h('p', hasRefund ? `退款金额：${amount}` : '无退款记录'),
              h('p', hasRefund ? `状态：${params.row.refund_records[0].status === 1 ? '已退款' : '未退款'}` : ''), // 新增状态显示
              hasRefund ? h('Button', {
                props: { type: 'primary' },
                on: { click: () => this.showRefundRecords(params.row) }
              }, '查看明细') : null
            ]);
          }
        },
        {
          title: '占位费信息',
          key: 'placeholder_info',
          minWidth: 125,
          align: 'center',
          render: (h, params) => {
            const hasPlaceholder = params.row.has_placeholder;
            const amount = params.row.placeholder_total_amount_format;
            return h('div', [
              h('p', hasPlaceholder ? `占位费金额：${amount}` : '无占位费记录'),
              h('p', hasPlaceholder ? `状态：${params.row.placeholder_orders[0].status === 1 ? '已支付' : '未支付'}` : ''), // 新增状态显示
              hasPlaceholder ? h('Button', {
                props: { type: 'primary' },
                on: { click: () => this.showPlaceholderOrders(params.row) }
              }, '查看明细') : null
            ]);
          }
        },
        {
          title: '充电状态',
          key: 'status',
          minWidth: 60,
          align: 'center',
          render: (h, params) => {
            const statusMap = {
              1: '启动中',
              2: '充电中',
              3: '停止中',
              4: '已停止',
              5: '未知'
            };
            return h('span', statusMap[params.row.status] || '未知');
          }
        },
        { title: '创建时间', key: 'create_time', minWidth: 80, align: 'center' },
      ],
      refundRecordsColumns: [
        { title: '退款ID', key: 'id', minWidth: 150, align: 'center' },
        { title: '金额', key: 'refund_amount', minWidth: 150, align: 'center' },
        {
          title: '是否已退款',
          key: 'status',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            const statusMap = {
              0: '未退款',
              1: '已退款'
            };

            // 判断是否为未退款状态
            if (params.row.status === 0) {
              return h('div', [
                h('span', statusMap[params.row.status]),
                h('Button', {
                  props: { type: 'primary', size: 'small' },
                  style: { marginLeft: '10px' },
                  on: {
                    click: () => this.handleRefund(params.row) // 触发退款方法
                  }
                }, '退款')
              ]);
            } else {
              return h('span', statusMap[params.row.status] || '未知状态');
            }
          }
        },
        { title: '创建时间', key: 'create_time', minWidth: 150, align: 'center' },
        { title: '退款时间', key: 'refund_time', minWidth: 150, align: 'center' },
        ],
      placeholderOrdersColumns:[
        { title: '占位费ID', key: 'id', minWidth: 150, align: 'center' },
        { title: '金额', key: 'amount', minWidth: 150, align: 'center' },
        {
          title: '是否已支付',
          key: 'status',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            const statusMap = {
              0: '未支付',
              1: '已支付'
            };
            return h('span', statusMap[params.row.status] || '未知状态');
          }
        },
        { title: '创建时间', key: 'create_time', minWidth: 150, align: 'center' },
        { title: '支付时间', key: 'pay_time', minWidth: 150, align: 'center' },
      ]
    };
  },
  methods: {
    doneFunction(res) {
      const extra = res.extra || {};
      this.statistics = {
        total_placeholder_amount: extra.total_placeholder_amount || 0,
        total_placeholder_count: extra.total_placeholder_count || 0,
        total_refund_amount: extra.total_refund_amount || 0,
        total_refund_count: extra.total_refund_count || 0
      };
    },
    showPlaceholderOrders(row) {
      this.placeholderOrders = row.placeholder_orders;
      this.showPlaceholderDialog = true;
    },
    showRefundRecords(row) {
      this.refundRecords = row.refund_records;
      this.showRefundDialog = true;
    },
    exportData(){
      // 防止重复点击
      if (this.exportLoading) {
        console.log('导出正在进行中，请稍候...');
        return;
      }
      
      console.log('开始执行导出，时间:', new Date().toISOString());
      this.exportLoading = true;
      
      this.$commonFun.postProxy('admin/xindian_order/exportOrderLists',this.searchData).then((res)=>{
        this.exportLoading = false;
        console.log('导出请求完成，结果:', res);
        
        this.$commonFun.dealApiResult(res,()=>{
          let worksheet = XLSX.utils.aoa_to_sheet(res.data)
          let workbook = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(workbook,worksheet,'sheet1')
          XLSX.writeFile(workbook,`充电订单.xlsx`)
        })
      }).catch(error => {
        this.exportLoading = false;
        console.error('导出请求失败:', error);
      })
    },
    handleRefund(row) {
      let refundRemark = ''; // 用于存储用户输入的备注信息
      // 弹出确认框，提示用户是否确认发起退款操作，并允许输入备注
      this.$Modal.confirm({
        title: '确认退款',
        render: (h) => {
          return h('div', [
            h('p', `确定要为订单 ${row.id} 发起退款吗？`),
            h('Input', {
              props: {
                value: refundRemark,
                placeholder: '请输入退款备注（可选）',
                type: 'textarea',
                rows: 3
              },
              on: {
                input: (value) => {
                  refundRemark = value; // 实时更新备注信息
                }
              }
            })
          ]);
        },
        onOk: () => {
          // 调用退款接口，传入订单ID和备注信息
          this.$commonFun.postProxy('admin/xindian_order/processRefund', {
            start_charge_seq: row.start_charge_seq,
            refund_amount: row.refund_amount,
            refund_record_id: row.id,
            remark: refundRemark // 将备注信息传递给后端
          }).then(res => {
            this.$commonFun.dealApiResult(res, () => {
              this.$Message.success('退款成功');
              this.$refs.table.getLists(); // 刷新表格数据
              //刷新当前页面
              this.showRefundDialog = false;
            });
          });
        }
      });
    },
    handleQueryBilling(row) {
      this.$Modal.confirm({
        title: '确认查询',
        content: `确定要查询订单 ${row.id} 的计费信息吗？`,
        onOk: () => {
          this.$commonFun.postProxy('admin/xindian_order/triggerBillingQuery', {
            start_charge_seq: row.start_charge_seq,
            id: row.id
          }).then(res => {
            this.$commonFun.dealApiResult(res, () => {
              this.$Message.success('查询请求已发送');
              // 可以选择是否刷新表格数据
               this.$refs.table.getLists();
            });
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.charging-order-list {
  padding: 20px;
}
</style>